import React, { useMemo, useState } from 'react'
import moment from 'moment-timezone'
import { Badge } from 'reactstrap'
import { AnnouncementActionsMenu } from './AnnouncementActions'
import { announcementActive, announcementCompetition, readAnnouncementContent } from './announcementContent'
import { getAnnouncementSourceLabel } from './announcementDisplay'
import AnnouncementNotificationStatus from './AnnouncementNotificationStatus'
import TranslationMarker from 'components/Common/TranslationMarker'
import { blockAttention } from 'components/Common/localizedText'

export function AnnouncementCompetitions({ ids = [], competitions }) {
  return <div className="announcement-competitions" aria-label="Selected competitions">{ids.map(id => {
    const option = announcementCompetition(id, competitions)
    return <span className={'announcement-competition' + (option.isDisabled ? ' is-disabled' : '')} key={id}>{option.label}</span>
  })}</div>
}

export default function AnnouncementCard({ announcement, event, socketClientId, getEventDetails }) {
  const [expanded, setExpanded] = useState(false)
  const content = useMemo(() => readAnnouncementContent(announcement.message), [announcement.message])
  const timezone = moment.tz.zone(event.timezone) ? event.timezone : 'Europe/Bucharest'
  const date = announcement.createdAt ? moment(announcement.createdAt) : null
  const active = announcementActive(announcement)
  const contentId = 'announcement-body-' + announcement._id
  return <article className={'announcement-record' + (announcement.status === 'DISABLED' ? ' is-disabled' : '')} aria-label={announcement.title || 'Untitled announcement'}>
    <div className="announcement-card-heading">
      <h3>{announcement.title || 'Untitled announcement'}</h3>
      <div className="announcement-badges"><Badge color={active ? 'success' : 'secondary'}>{active ? 'Active' : announcement.status === 'DISABLED' ? 'Disabled' : 'Unavailable'}</Badge>{announcement.pinned && <Badge color="warning">Pinned</Badge>}
        <TranslationMarker attention={blockAttention(announcement.localizedTexts?.announcement)} blockName="Title, Message" /></div>
    </div>
    {content.valid ? <>
      <div id={contentId} className={'announcement-body' + (expanded ? '' : ' is-collapsed')} dangerouslySetInnerHTML={{ __html: content.html || '<p>No message content.</p>' }} />
      {content.hasContent && <button className="btn btn-link announcement-expand" type="button" aria-expanded={expanded} aria-controls={contentId} onClick={() => setExpanded(!expanded)}>{expanded ? 'Show less' : 'Show more'}</button>}
    </> : <p role="status">Message unavailable. The saved content could not be read.</p>}
    <div className="announcement-targets"><AnnouncementNotificationStatus announcement={announcement} timezone={timezone} />
      <AnnouncementCompetitions ids={announcement.notificationSummary?.competitions || announcement.competitions} competitions={event.competitions} />
    </div>
    <footer className="announcement-footer">
      <div className="announcement-meta"><span>{getAnnouncementSourceLabel(announcement, event)}</span><span>{date?.isValid() ? date.tz(timezone).format('DD MMM YYYY, HH:mm') : 'Date unavailable'} · {timezone}</span></div>
      <AnnouncementActionsMenu data={announcement} eventId={event._id} getEventDetails={getEventDetails} socketClientId={socketClientId} />
    </footer>
  </article>
}
